/** Normalisierung für Duplikat-Vergleich */

export function normPhone(tel) {
  if (!tel) return '';
  let s = String(tel).replace(/\D/g, '');
  // Normalize +49 / 0049 prefix to bare number so +4915123... and 015123... match
  if (s.length >= 12 && s.startsWith('49')) s = s.slice(2);
  if (s.startsWith('0')) s = s.slice(1);
  return s;
}

export function normDomain(domainOrEmail) {
  if (!domainOrEmail) return '';
  let s = String(domainOrEmail).trim().toLowerCase();
  if (s.includes('@')) {
    s = s.split('@')[1] || '';
  }
  s = s.replace(/^www\./, '').replace(/\/$/, '');
  return s;
}

export function normCompany(name) {
  if (!name) return '';
  return String(name)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/gmbh|ag|kg|ug|e\.k\.|e\.v\.|ohg|mbh/gi, '')
    .replace(/[^a-z0-9äöüß\s]/gi, '')
    .trim();
}

/**
 * Gruppen von Lead-IDs, die wahrscheinlich dieselbe Person/Firma sind.
 * Regel: gleiche Telefonnummer (mind. 8 Ziffern) ODER gleiche Domain ODER (gleiche Firma UND gleiche PLZ).
 */
export function findDuplicateClusters(leads) {
  const map = new Map(); // key -> Set(ids)

  function add(key, id) {
    if (!key) return;
    if (!map.has(key)) map.set(key, new Set());
    map.get(key).add(String(id));
  }

  for (const l of leads || []) {
    const id = l.id;
    const ph = normPhone(l.tel);
    if (ph.length >= 8) add(`tel:${ph}`, id);
    const dm = normDomain(l.domain || l.email);
    if (dm.length >= 3) add(`dom:${dm}`, id);
    const co = normCompany(l.company);
    const zip = (l.zip || '').trim();
    if (co.length >= 4 && zip.length >= 4) add(`coz:${co}|${zip}`, id);
  }

  const clusters = [];
  const seen = new Set();
  for (const [, ids] of map) {
    if (ids.size < 2) continue;
    const arr = [...ids].sort();
    const sig = arr.join(',');
    if (seen.has(sig)) continue;
    seen.add(sig);
    const members = arr.map(sid => leads.find(x => String(x.id) === sid)).filter(Boolean);
    clusters.push({ key: sig, leadIds: arr, leads: members });
  }
  return clusters;
}
